export default "__VITE_ASSET__DKxZjX4U__"